import React from 'react'

import background from './../UI/Intro.webp'

import {getProyecto, getDropboxFiles} from './../services/renders.dao'
import { ContextLoader } from "./../utils/import.frames";

import LoadingScreen from './ingreso/loadingScreen.component';
import WelcomeScreen from './ingreso/welcomeScreen.component';
import Canvas from './canvas.component';

interface Ingreso{
    general: Array<String>
    torre1: Array<String>
    torre2: Array<String>
    images: Array<String>
    porteria: Array<String>
    terraza: Array<String>
    actio: Array<String>
    cancha: Array<String>
    acuatica: Array<String>
    asoleacion: Array<String>
    jacuzzi: Array<String>
    wifi: Array<String>
    eventos: Array<String>
    crossfit: Array<String>
    fisica: Array<String>
    yoga: Array<String>
    lectura: Array<String>
    estadia: Array<String>
    masajes: Array<String>
    ping: Array<String>
    bbq: Array<String>
    piscina: Array<String>
    parque: Array<String>
    habilidades: Array<String>
    guarderia: Array<String>
    pet: Array<String>
}

interface Props{}

interface State{
    isLoading: boolean,
    proyecto: any,
    textures: any,
    gettingProjectInfo: boolean,
    errorGettingProjectInfo: boolean,
    downloadingImagesInfo: boolean,
    errorDowloadingImages: boolean,
    loadedImages: number,
    isWelcome: boolean,
    dissapearWelcome: boolean
}

class Ingreso extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isLoading: true,
            proyecto: {},
            textures: {},
            gettingProjectInfo: true,
            errorGettingProjectInfo: false,
            downloadingImagesInfo: false,
            errorDowloadingImages: false,
            loadedImages: 0,
            isWelcome: false,
            dissapearWelcome: true
        }
    }

    async componentDidMount(){
        try {
            this.setState({
                proyecto: await getProyecto()
            }, async () => {
                try{
                    const texts =  await getDropboxFiles()
                    var result = texts.data.files
                    var dicc: any = {}


                    result.forEach((element: any) => {
                        dicc[element.path] = element.link
                    });
                    this.setState({
                        textures: dicc
                    }, () => {
                        this.setState({
                            gettingProjectInfo: false
                        }, () => {
                            this.setState({
                                downloadingImagesInfo: true
                            })
                            this.general = ContextLoader["General View"]()
                            this.torre1 = ContextLoader["Torre 1"]()
                            this.torre2 = ContextLoader["Torre 2"]()
                            this.terraza = ContextLoader["Terraza Aurora (Piso 31)"]()
                            this.actio = ContextLoader["Salón Actio"]()
                            this.cancha = ContextLoader["Cancha Multifuncional"]()
                            this.acuatica = ContextLoader["Zona Acúatica - Carril de Nado"]()
                            this.asoleacion = ContextLoader["Zona de Asoleación"]()
                            this.jacuzzi = ContextLoader["Asoleación - Jacuzzi Seco"]()
                            this.wifi = ContextLoader["Terraza WiFi"]()
                            this.eventos = ContextLoader["Salón de Eventos"]()
                            this.crossfit = ContextLoader["Zona Crossfit al Aire Libre"]()
                            this.fisica = ContextLoader["Centro de Actividad Física"]()
                            this.yoga = ContextLoader["Deck de Yoga"]()
                            this.lectura = ContextLoader["Zona de Lectura al Aire Libre"]()
                            this.estadia = ContextLoader["Zona de Estadía Aire Libre"]()
                            this.masajes = ContextLoader["Zona de Masajes"]()
                            this.ping = ContextLoader["Zona de Ping Pong"]()
                            this.bbq = ContextLoader["Zona BBQ"]()
                            this.piscina = ContextLoader["Piscina para Niños con Estadero"]()
                            this.parque = ContextLoader["Parque Infantil"]()
                            this.habilidades = ContextLoader["Habilidades Múltiples Infantiles"]()
                            this.guarderia = ContextLoader["Guardería"]()
                            this.pet = ContextLoader["Zona Pet Friendly"]()

                            this.images = [
                                this.general[0],
                                this.general[6],
                                this.general[12],
                                this.general[18],
                                this.general[24],
                                this.general[30],
                                this.general[36],
                                this.general[42],
                                this.general[48],
                                this.general[54],
                                this.general[60],
                                this.general[66],

                                this.torre1[0],
                                this.torre1[6],
                                this.torre1[12],
                                this.torre1[18],
                                this.torre1[24],
                                this.torre1[30],
                                this.torre1[36],
                                this.torre1[42],
                                this.torre1[48],
                                this.torre1[54],
                                this.torre1[60],
                                this.torre1[66],

                                this.torre2[0],
                                this.torre2[6],
                                this.torre2[12],
                                this.torre2[18],
                                this.torre2[24],
                                this.torre2[30],
                                this.torre2[36],
                                this.torre2[42],
                                this.torre2[48],
                                this.torre2[54],
                                this.torre2[60],
                                this.torre2[66],

                                this.terraza[0],
                                this.actio[0],
                                this.cancha[0],
                                this.acuatica[0],
                                this.asoleacion[0],
                                this.jacuzzi[0],
                                this.wifi[0],
                                this.eventos[0],
                                this.crossfit[0],
                                this.fisica[0],
                                this.yoga[0],
                                this.lectura[0],
                                this.estadia[0],
                                this.masajes[0],
                                this.ping[0],
                                this.bbq[0],
                                this.piscina[0],
                                this.parque[0],
                                this.habilidades[0],
                                this.guarderia[0],
                                this.pet[0],

                                this.terraza[1],
                                this.actio[1],
                                this.cancha[1],
                                this.acuatica[1],
                                this.asoleacion[1],
                                this.jacuzzi[1],
                                this.wifi[1],
                                this.eventos[1],
                                this.crossfit[1],
                                this.fisica[1],
                                this.yoga[1],
                                this.lectura[1],
                                this.estadia[1],
                                this.masajes[1],
                                this.ping[1],
                                this.bbq[1],
                                this.piscina[1],
                                this.parque[1],
                                this.habilidades[1],
                                this.guarderia[1],
                                this.pet[1]
                            ]

                            this.images.forEach((src: any) => {
                                new Promise((resolve, reject) => {
                                    const img = new Image();
                                    img.src = src

                                    img.onload = (event) => {
                                        this.setState({
                                            loadedImages: this.state.loadedImages + 1 
                                        }, () => {
                                            if(this.state.loadedImages === this.images.length){
                                                this.setState({
                                                    downloadingImagesInfo: false,
                                                    isLoading: false
                                                })
                                            }
                                        })
                                    }
                                    img.onerror = (err) => {
                                        reject()
                                    }
                                }).catch((e) => {
                                    this.setState({
                                        errorDowloadingImages: true
                                    }, () => {console.log(e)})
                                })
                            })
                        })
                    })
                }
                catch(err){
                    this.setState({
                        errorGettingProjectInfo: true
                    }, () => {console.log(err)})
                }
            })
        }
        catch(err){
            this.setState({
                errorGettingProjectInfo: true
            }, () => {console.log(err)})
        }
    }

    handleHideWelcomeScreen = () => {
        this.setState({
            isWelcome: true
        })
        setTimeout(function(this: any){
            this.setState({
                dissapearWelcome: false
            })
        }.bind(this), 700)
    }

    render(): React.ReactNode {
        return(
            <div className='ingreso-page'>
                <img src={background} className='background-image' alt=""/>
                <LoadingScreen 
                    isLoading = {this.state.isLoading}
                    gettingProjectInfo={this.state.gettingProjectInfo}
                    errorGettingProjectInfo={this.state.errorGettingProjectInfo}
                    downloadingImagesInfo={this.state.downloadingImagesInfo}
                    errorDownloadingImages={this.state.errorDowloadingImages}
                />
                {this.state.isLoading === false  ?
                    <Canvas 
                        isWelcome = {this.state.isWelcome}
                        proyecto = {this.state.proyecto.data}
                        textures = {this.state.textures}
                        loadedImages={this.state.loadedImages}
                    /> : null
                }
                {this.state.dissapearWelcome ?
                    <WelcomeScreen 
                        isLoading = {this.state.isLoading}
                        isWelcome = {this.state.isWelcome}
                        handleHideWelcome={this.handleHideWelcomeScreen}
                    />: null
                }
            </div>
        )
    }
}

export default Ingreso